@if (isPreviewDisplayed && modal) {
    <iu-modal-ui
        #modalRef
        [angularStyle]="modalStyle"
        [appendTo]="appendTo"
        [hasFooter]="true"
        (closeModalEmitter)="isPreviewDisplayed = false; showError = false">
        <ng-container
                [ngTemplateOutlet]="mainTemplate"
                [ngTemplateOutletContext]="{
        dataUrl: dataUrl,
        innerHtmlContent: innerHtmlContent,
        isImagePreview: isImagePreview,
        modal: modal,
        imgStyle: imgStyle,
        fileName: fileName,
        showError: showError,
        isDocPreview: isDocPreview,
        mediaType: mediaType,
      }"/>
        <ng-content/>
    </iu-modal-ui>
}

@if (overlay) {
    <iu-prime-overlay #opRef [appendTo]="appendTo" [handleAlign]="handleAlign.bind(this)">
        <div class="usearch-file-preview">
            <ng-container
                    [ngTemplateOutlet]="mainTemplate"
                    [ngTemplateOutletContext]="{
          dataUrl: dataUrl,
          innerHtmlContent: innerHtmlContent,
          isImagePreview: isImagePreview,
          modal: modal,
          imgStyle: imgStyle,
          fileName: fileName,
          showError: showError,
          isDocPreview: isDocPreview,
          mediaType: mediaType,
        }"/>
        </div>
    </iu-prime-overlay>
}

@if (isPreviewDisplayed && !modal && !overlay) {
    <ng-container
            [ngTemplateOutlet]="mainTemplate"
            [ngTemplateOutletContext]="{
      dataUrl: dataUrl,
      innerHtmlContent: innerHtmlContent,
      isImagePreview: isImagePreview,
      modal: modal,
      imgStyle: imgStyle,
      fileName: fileName,
      showError: showError,
      isDocPreview: isDocPreview,
      mediaType: mediaType,
    }"/>
}

<ng-template
    #mainTemplate
    let-dataUrl="dataUrl"
    let-fileName="fileName"
    let-imgStyle="imgStyle"
    let-innerHtmlContent="innerHtmlContent"
    let-isDocPreview="isDocPreview"
    let-isImagePreview="isImagePreview"
    let-isPreviewDisplayed="isPreviewDisplayed"
    let-mediaType="mediaType"
    let-modal="modal"
    let-showError="showError">
    @if (isLoading) {
        <div class="iu-preview-doc-loading" role="status" aria-live="polite" data-cy="preview-loading">
            <div class="iu-preview-doc-skeleton" aria-hidden="true">
                <span></span><span></span><span></span><span></span>
            </div>
            <span class="iu-preview-doc-loading-label">
                <i aria-hidden="true" class="icon-spinner fa-spin"></i>
                {{ 'previewDoc.loading' | translate }}
            </span>
        </div>
    } @else if (isUnsupported || hasPreviewError || showError || (isDocPreview && !dataUrl && !innerHtmlContent)) {
        <div class="iu-preview-doc-fallback" data-cy="preview-fallback">
            <i aria-hidden="true" class="iu-preview-doc-fallback-icon" [class]="fileIconClass"></i>
            <span class="iu-preview-doc-fallback-name" [title]="fileName ?? ''">{{ fileName }}</span>
            @if (fileSizeLabel) {
                <span class="iu-preview-doc-fallback-size">{{ fileSizeLabel }}</span>
            }
            <span class="iu-preview-doc-fallback-msg">
                {{ (showError ? 'previewDoc.noExtension' : hasPreviewError ? 'previewDoc.noPreview' : 'previewDoc.unavailable') | translate }}
            </span>
            @if (canDownload) {
                <button class="p-button p-button-primary iu-preview-doc-fallback-btn" type="button" data-cy="preview-fallback-download" (click)="download()">
                    <i aria-hidden="true" class="icon-download"></i>
                    {{ 'generic.download' | translate }}
                </button>
            }
        </div>
    }

    @if (!isLoading && (dataUrl || innerHtmlContent)) {
        @if (isImagePreview) {
            <img
                    class="previewImg"
                    [class.is-zoomed]="imageZoomed"
                    [alt]="fileName"
                    [attr.data-cy]="modal ? 'modal-preview-data' : 'preview-data'"
                    [title]="(imageZoomed ? 'previewDoc.zoomOut' : 'previewDoc.zoomIn') | translate"
                    [width]="'100%'"
                    [height]="'max-content'"
                    [ngSrc]="dataUrl"
                    [ngStyle]="imageZoomed ? null : imgStyle"
                    (click)="toggleImageZoom()"/>
        }

        @if (['sh', 'txt', 'csv', 'xlsx'].includes(extension) && innerHtmlContent) {
            <div class="other-viewer" [innerHTML]="innerHtmlContent"></div>
        } @else {
            @switch (extension) {
                @case ('pdf') {
                    <iu-pdf-viewer [attr.data-cy]="modal ? 'modal-preview-data' : 'preview-data'" [dataUrl]="dataUrl"/>
                }
                @case ('xml') {
                    <iu-xml-viewer [attr.data-cy]="modal ? 'modal-preview-data' : 'preview-data'" [blob]="blob"/>
                }
            }
        }

        @if (showError) {
            {{ 'previewDoc.noExtension' | translate }}
        }

        <!-- TODO: check if this is necessary -->
        <ng-template #docError>
            @if (isDocPreview) {
                <p>
                    {{ 'previewDoc.noPreview' | translate }}
                    <a target="_blank" [download]="fileName"
                       [href]="dataUrl"> {{ 'previewDoc.downloadIt' | translate }}</a>
                </p>
            }
        </ng-template>
    }
</ng-template>
